import React from 'react';
import { Tag, Tooltip } from 'antd';
import { compare } from 'natural-orderby';

function formatCNPJ(value) {
    if (!value) return '-';
    var digits = value.replace(/\D/g, '');
    if (digits.length !== 14) return value;
    return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
}

var COL = {
    check: 50, cod: 80, name: 250, cnpj: 170,
    partner: 220, cpf: 150, pct: 80, phone: 160
};

var TABLE_W = Object.keys(COL).reduce(function(s, k) { return s + COL[k]; }, 0);

var SORTERS = {
    customer_cod: function(a, b) { return compare()(a.customer_cod, b.customer_cod); },
    customer_name: function(a, b) { return (a.customer_name || '').localeCompare(b.customer_name || ''); },
    partner_name: function(a, b) { return (a.partner_name || '').localeCompare(b.partner_name || ''); },
    partner_percentage: function(a, b) { return (a.partner_percentage || 0) - (b.partner_percentage || 0); },
};

export { COL, TABLE_W, SORTERS, formatCNPJ };
